import { Box } from "@mui/material";
import { Button, FormDataConsumer, required, SelectInput, SimpleForm, TextInput, useRecordContext } from "react-admin";
import CustomDeletedDialogToolbar from "shared/components/toolbars/CustomDeletedDialogToolbar";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";
import { franceGroupTypeChoices, groupModeChoices } from "shared/enums/reactAdminChoices";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";

import { CodeTmInput } from "../shared/groupInputs";

type GroupEditFormProps = {
  handleSubmit: (values: any) => void;
};

const GroupEditForm = ({ handleSubmit }: GroupEditFormProps) => {
  const record = useRecordContext();
  const isFrance = Object.values(FranceGroupTypeEnum).includes(record?.type as FranceGroupTypeEnum);

  return (
    <SimpleForm
      onSubmit={handleSubmit}
      mode="onBlur"
      shouldUnregister
      toolbar={
        <CustomDeletedDialogToolbar isCreateMode={false} resource={SiteResourcesEnum.Groups} resourceKey={"Group"}>
          <Button label="Save" type="submit" size="large" variant="contained" />
        </CustomDeletedDialogToolbar>
      }
    >
      <TextInput source="name" validate={required()} />
      <SelectInput source="mode" choices={groupModeChoices} validate={required()} />
      <TextInput source="code" validate={required()} />

      <FormDataConsumer>
        {({ formData }) => {
          const { type, code } = formData;

          return (
            <Box width={"100%"}>
              <Box display={"flex"} columnGap={2}>
                {isFrance && <SelectInput source="type" choices={franceGroupTypeChoices} validate={required()} />}

                <CodeTmInput type={type} code={code} />
              </Box>
            </Box>
          );
        }}
      </FormDataConsumer>
    </SimpleForm>
  );
};

export default GroupEditForm;
